/**
 * Pure helpers for the phase-2 broadcast thunks: reading the server's messages out of a failed
 * /responses call, and turning an export answer (bytes + headers) into a browser download.
 */

export const GENERIC_SUBMIT_ERROR = "Your answers could not be submitted. Please try again.";

// The server's message array (422) or single string (404 etc.); the generic line otherwise.
export const responseErrors = (e) => {
    const message = e && e.data && e.data.error ? e.data.error.message : null;
    if (Array.isArray(message) && message.length) return message;
    if (typeof message === "string" && message) return [message];
    return [GENERIC_SUBMIT_ERROR];
};

// `attachment; filename=broadcast-41-responses-v2.csv` (quoted or not) -> the file name.
export const filenameFromDisposition = (disposition) => {
    const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(String(disposition || ""));
    return match ? match[1].trim() : null;
};

const header = (result, name) => {
    const headers = (result && result.headers) || {};
    const key = Object.keys(headers).find((k) => k.toLowerCase() === name);
    return key ? headers[key] : undefined;
};

// Same anchor-click download as the DTR / report exports, with the Blob typed from the
// Content-Type header and the name taken from Content-Disposition (SPEC 19.6).
export const downloadExport = (result, fallbackName) => {
    const type = header(result, "content-type") || "application/octet-stream";
    const name = filenameFromDisposition(header(result, "content-disposition")) || fallbackName;
    const url = window.URL.createObjectURL(new Blob([result.data], { type: type }));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", name);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    if (window.URL.revokeObjectURL) window.URL.revokeObjectURL(url);
};
